import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { AppScaleComponent, LanguageSelectorComponent } from '@layout/components';
import { LayoutService } from '@layout/services';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  imports: [
    RouterModule,
    CommonModule,
    TooltipModule,
    TranslateModule,
    AppScaleComponent,
    LanguageSelectorComponent,
    ButtonModule,
  ],
})
export class NotFoundComponent {
  constructor(public layoutService: LayoutService) {}
}
